import { genUID as genAlphaNumeric } from '@frontend/design-system';

export function genUID(): string {
  return genAlphaNumeric() + '-' + genAlphaNumeric();
}
